import { ImageAsset } from '@common/model/resource/image';

export const getAssetSrc = (asset: ImageAsset): string => (asset.webp ? asset.webp.src : asset.base.src);
